import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import toastr from "toastr"
import { getValidRedirectUrls } from "../../appRedux/slices/currentUser"
import "toastr/build/toastr.min.css"
import { AES, enc } from "crypto-js"
// import { getCurrentUser } from "../../appRedux/slices/currentUser"
//redux
import { useSelector, useDispatch } from "react-redux"
import {
  login,
  googlelogin,
  getClientId,
} from "../../clientServices/authService"
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

import { withRouter, Link, useLocation, Redirect } from "react-router-dom"

import GoogleLogin from "react-google-login"

import "./icon.css"
// import images
import logo from "../../assets/images/logo.svg"

// import "./icon.css"
import { Divider } from "antd"

const GoogleLoginPage = props => {
  const dispatch = useDispatch()
  const search = useLocation().search
  const name = new URLSearchParams(search).get("path")

  const [clientId, setClientId] = useState(undefined)
  const [message, setMessage] = useState(undefined)

  const [path, setPath] = useState(name)

  const { isValidRedirectUrl, loading, urlLoading } = useSelector(state => ({
    isValidRedirectUrl: _.get(state, "currentUser.isValidRedirectUrl"),
    loading: _.get(state, "currentUser.loading"),
    urlLoading: _.get(state, "currentUser.urlLoading"),
  }))

  useEffect(async () => {
    if (!urlLoading && path != null) {
      let isValidUrl = dispatch(getValidRedirectUrls({ path }))
    }
    let clientId = await getClientId()
    if (clientId) {
      var bytes = AES.decrypt(clientId, "googleClientId") // Decrypt the client ID
      var originalClientId = bytes.toString(enc.Utf8)
      setClientId(originalClientId)
    }
  }, [urlLoading])

  const responseGoogle = async response => {
    let emailArray =
      response.profileObj && response.profileObj.email
        ? response.profileObj.email.split("@")
        : []
    let [email, domain] = emailArray
    if (response && response.profileObj) {
     
      let res = await googlelogin({ token: response.tokenId })
      if (res && res.code && res.code === 200) {
        if (path != null) {
          window.location.assign(path)
        } else {
          window.location.assign(`${window.location.origin}/dashboard/home`)
        }
      }
      if (
        res &&
        res.code &&
        res.code === 500 &&
        res.message
      ) {
        setMessage(res.message)
      }
      //   dispatch(getCurrentUser())
    }
  }

  // handleValidSubmit
  const handleValidSubmit = async (event, values) => {
    try {
      console.log(process.env.NODE_ENV, "line 98")
      let response = await login(values)
      // dispatch(getCurrentUser())
      if (response.status && response.status === 200) {
        if (path != null) {
          window.location.assign(path)
        } else {
          window.location.assign(`${window.location.origin}/dashboard/home`)
        }
      } else {
        toastr.error("Invalid Credentials")
      }
    } catch (error) {
    } finally {
    }
  }

  if (message) {
    toastr.error(message)
  }

  return (
    <>
      {((isValidRedirectUrl && path != null) || (path == null)) ? (
        <React.Fragment>
          <MetaTags>
            <title>Login | Central Authorization Tool</title>
          </MetaTags>
          <div className="home-btn d-none d-sm-block">
            <Link to="/" className="text-dark">
              <i className="fas fa-home h2" />
            </Link>
          </div>
          <div className="account-pages my-5 pt-sm-5">
            <Container>
              <Row className="justify-content-center">
                <Col md={8} lg={6} xl={5}>
                  <Card className="overflow-hidden">
                    <div className="bg-primary bg-soft">
                      <Row>
                        <Col xs={7}>
                          <div className="text-primary p-4">
                            <h5 className="text-primary">Welcome !!</h5>
                            <p>
                              Sign in to continue to Central Authorization Tool.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <CardBody className="pt-0">
                      <div>
                        <Link to="/" className="auth-logo-light">
                          <div className="avatar-md profile-user-wid mb-4">
                            <span className="avatar-title rounded-circle bg-light">
                              <img
                                src={logo}
                                alt=""
                                className="rounded-circle"
                                height="34"
                              />
                            </span>
                          </div>
                        </Link>
                      </div>
                      <div className="px-2">
                        <AvForm
                          className="form-horizontal"
                          onValidSubmit={(e, v) => {
                            handleValidSubmit(e, v)
                          }}
                        >
                          {/* {error ? <Alert color="danger">{error}</Alert> : null} */}

                          <div className="mb-3">
                            <AvField
                              name="email"
                              label="Email"
                              value=""
                              className="form-control"
                              placeholder="Enter email"
                              type="email"
                              required
                            />
                          </div>

                          <div className="mb-3">
                            <AvField
                              name="password"
                              label="Password"
                              value=""
                              type="password"
                              required
                              placeholder="Enter Password"
                            />
                          </div>

                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customControlInline"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customControlInline"
                            >
                              Remember me
                            </label>
                          </div>

                          <div className="mt-3 d-grid">
                            <button
                              className="btn btn-primary btn-block py-2"
                              type="submit"
                            >
                              Log In
                            </button>
                          </div>

                          <Divider>
                            <span className="font-size-13 font-weight-semibold">
                              OR
                            </span>
                          </Divider>
                          <div>
                            {clientId && (
                              <GoogleLogin
                                clientId={clientId}
                                buttonText="Login with Google"
                                onSuccess={responseGoogle}
                                onFailure={responseGoogle}
                                cookiePolicy="single_host_origin"
                                render={renderProps => (
                                  <div className="mt-3 d-grid">
                                    <button
                                      className="btn btn-danger btn-block"
                                      onClick={renderProps.onClick}
                                      //   disabled={renderProps.disabled}
                                    >
                                      <div className="d-flex justify-content-center">
                                        <div>
                                          <i className="fab fa-google fa-2x px-2"></i>
                                        </div>
                                        <div className="pt-1">
                                          Log In with Google
                                        </div>
                                      </div>
                                    </button>
                                  </div>
                                )}
                              />
                            )}
                          </div>

                          <div className="mt-3 text-center">
                            <h5 className="font-size-14 mb-3">Sign in </h5>
                          </div>

                          <div className="mt-4 text-center">
                            <Link to="/forgot-password" className="text-muted">
                              <i className="mdi mdi-lock me-1" />
                              Forgot your password?
                            </Link>
                          </div>
                        </AvForm>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="mt-5 text-center">
                    <p>
                      © {new Date().getFullYear()} Central Authorization Tool
                      <i className="mdi mdi-heart text-danger" />
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </React.Fragment>
      ) :  <div className="font-size-16 text-center text-muted font_italic_bold center_div">
        Invalid redirect URL
    </div>}
    </>
  )
}

export default withRouter(GoogleLoginPage)

GoogleLoginPage.propTypes = {
  history: PropTypes.object,
}
